import {Setting} from "../../../setting/Setting";
import {DraftComponent, DraftElement} from "../../../../../../../feature/Draft";
import {combineSettingDescription} from "../list/SettingList";
import {
    assistantAsking,
    assistantAskingForAction,
    assistantAskingForContext,
    assistantAskingForExample,
    assistantAskingForGenre,
    assistantAskingForInstructions,
    assistantAskingForRequirements,
    assistantAskingForSchema,
    assistantAskingForSynopsis, systemInstruction, userSaying
} from "../../../../../../../ai/Utils";


export const generateSettingElementsPrompt = (vars: {
    category: Setting,
    genres: string[],
    synopsis: string,
    setting?: string,
    component: DraftComponent,
    context?: string[]
}) => systemInstruction("Ты профессиональный гейм-дизайнер")
    .concat(userSaying("Я работаю над созданием сеттинга для литературного произведения. Нужно подробно описать компонент сеттинга."))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши кратко сеттинг игры", vars.setting))
    .concat(assistantAsking("Опиши категорию сеттинга", vars.category ? combineSettingDescription(vars.category) : undefined))
    .concat(assistantAsking("Опиши компонент сеттинга", vars.component.description))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        "Проанализируй краткое содержание (синопсис)",
        "Проанализируй описание сеттинга",
        "Проанализируй описание категории сеттинга",
        "Проанализируй компонент сеттинга и разбей его на элементы",
        "Сгенерируй подробные элементы сеттинга",
        "Придумай названия объектам/элементам",
    ]))
    .concat(assistantAskingForRequirements([
        "Элементы сеттинга должны быть подробным",
        "Элементы сеттинга должны быть уникальными и соответствовать жанру",
        "Результат должен быть в формате json",
    ]))
    .concat(assistantAskingForSchema('{"data": [{"id":number, "title":string, "description":string}]}'))
    .concat(assistantAskingForExample({
        data: [
            {
                id: 1,
                title: "Флора",
                description: "Гигантские деревья и цветы"
            },
            {
                id: 2,
                title: "Фауна",
                description: "В основном мелкие животные"
            },
            {
                id: 3,
                title: "Погода",
                description: "Вечный дождь"
            },
            {
                id: 4,
                title: "Циклы",
                description: "День длится 3 часа, ночь 3 часа"
            }
        ]
    }))
    .concat(assistantAskingForAction(`Опиши компонент ${vars.component.title} сеттинга 
    ${vars.category.title}${vars.category.prompt.element.list}`))

export const generateSettingElementPrompt = (vars: {
    category?: Setting,
    genres: string[],
    customPrompt?: string,
    synopsis?: string,
    component: DraftComponent,
    setting?: string,
    context?: string[]
}) => systemInstruction("Ты профессиональный гейм-дизайнер")
    .concat(userSaying("Я работаю над созданием сеттинга для литературного произведения. Нужно придумать элемент сеттинга."))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши кратко сеттинг игры", vars.setting))
    .concat(assistantAsking("Опиши категорию сеттинга", vars.category ? combineSettingDescription(vars.category) : undefined))
    .concat(assistantAsking("Опиши компонент сеттинга", vars.component.description))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        "Проанализируй краткое содержание (синопсис)",
        "Проанализируй описание сеттинга",
        "Проанализируй описание категории сеттинга",
        "Проанализируй контекст",
        "Свяжи генерируемый элемент с другими элементами из контекста",
        "Сгенерируй один элемент сеттинга",
        "Придумай названия объектам",
        "Разбей текст на абзацы",
    ]))
    .concat(assistantAskingForRequirements([
        "Элемент сеттинга должен быть подробным",
        "Элемент сеттинга должен быть уникальным и соответствовать жанру",
        "Элемент сеттинга не должен повторяться с другими элементами",
        "Используй все пять чувств для создания более живого описания элемента: запахи, звуки, текстуру, вкус и визуальные образы.",
        "Не применяй форматирование текста.",
        "Результат должен быть в формате json",
    ]))
    .concat(assistantAskingForSchema('{"data": {"id":number, "title":string, "description":string}}'))
    .concat(assistantAskingForExample({
        data: {
            id: 1,
            title: "Флора",
            description: "Гигантские деревья и цветы"
        }
    }))
    .concat(assistantAskingForAction(`Нужно придумать элемент сеттинга. ${vars.customPrompt ? ('\n\n' + vars.customPrompt) : ''}`))


export const improveSettingElementPrompt = (vars: {
    genres: string[],
    customPrompt?: string,
    synopsis?: string,
    setting?: string,
    component: DraftComponent,
    element: DraftElement
    context?: string[]
}) => systemInstruction("Ты профессиональный гейм-дизайнер")
    .concat(userSaying("Я работаю над созданием сеттинга для литературного произведения. Нужно подробно описать элемент сеттинга."))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши кратко сеттинг игры", vars.setting))
    .concat(assistantAsking("Опиши компонент сеттинга", vars.component.description))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        "Проанализируй краткое содержание (синопсис)",
        "Проанализируй описание сеттинга",
        "Проанализируй элемент сеттинга",
        "Проанализируй контекст",
        "Свяжи генерируемый элемент с другими элементами из контекста",
        "Наполни элемент сеттинга деталями",
        "Придумай названия объектам",
        "Разбей текст на абзацы",
    ]))
    .concat(assistantAskingForRequirements([
        "Элемент сеттинга должен быть подробным",
        "Элемент сеттинга должен быть уникальным и соответствовать жанру",
        "Элемент сеттинга не должен повторяться с другими элементами",
        "Используй все пять чувств для создания более живого описания элемента: запахи, звуки, текстуру, вкус и визуальные образы.",
        "Не применяй форматирование текста.",
        "Результат должен быть в формате json",
    ]))
    .concat(assistantAskingForSchema('{"data": {"id":number, "title":string, "description":string}}'))
    .concat(assistantAskingForExample({
        data: {
            id: 1,
            title: "Флора",
            description: "Гигантские деревья и цветы"
        }
    }))
    .concat(assistantAskingForAction(`Нужно доработать и улучшить элемент сеттинга: ${JSON.stringify({
        title: vars.element.title,
        description: vars.element.description
    })}.${vars.customPrompt ? ('\n\n' + vars.customPrompt) : ''}`))

